import { hasOwnProperty } from './utils';
import { Translated, VenueTemplateTranslation } from '../../shared/types/translation';
import { VenueTemplate, BareVenueTemplate } from '../../shared/types/venueTemplate';

export function translateVenueTemplate(
  venueTemplate: BareVenueTemplate,
  translation?: VenueTemplateTranslation,
  lang?: string
): Translated<BareVenueTemplate> | undefined;
export function translateVenueTemplate(
  venueTemplate: VenueTemplate,
  translation?: VenueTemplateTranslation,
  lang?: string
): Translated<VenueTemplate> | undefined;
export function translateVenueTemplate(
  venueTemplate: BareVenueTemplate | VenueTemplate,
  translation?: VenueTemplateTranslation,
  lang?: string
): Translated<BareVenueTemplate | VenueTemplate> | undefined {
  if (!translation || !lang) return undefined;
  const { transforms: transforms } = translation;

  if (!transforms || !hasOwnProperty(transforms, lang) || !transforms[lang].active) {
    return undefined;
  }

  return {
    ...venueTemplate,
    name: transforms[lang].delta.name,
    _lang: lang,
  };
}
